import { CapoPlugin } from "/codebuild/output/src545853651/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];